// packages/frontend/src/components/gmail/CalendarReconnectBanner.tsx
import { useEffect, useState } from 'react';
import { CalendarClock, X, RefreshCw } from 'lucide-react';
import { useGmailStore } from '../../store/gmailStore';

/**
 * Dismissible (per session) banner nudging reps whose Google token lost the
 * calendar scope to reconnect. Renders nothing unless a reconnect is needed.
 */
export const CalendarReconnectBanner = () => {
  const { needsCalendarReconnect, isConnecting, initiateCalendarSync, fetchStatus } = useGmailStore();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('calendarReconnectDismissed') === '1',
  );

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  if (!needsCalendarReconnect || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem('calendarReconnectDismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800 text-sm text-amber-800 dark:text-amber-300">
      <CalendarClock className="w-4 h-4 flex-shrink-0" />
      <span className="flex-1">
        Reconnect Google to turn calendar sync back on — scheduled activities aren&apos;t reaching your calendar.
      </span>
      <button
        onClick={initiateCalendarSync}
        disabled={isConnecting}
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-amber-600 hover:bg-amber-700 text-white text-xs font-medium disabled:opacity-50"
      >
        <RefreshCw className={`w-3 h-3 ${isConnecting ? 'animate-spin' : ''}`} />
        Reconnect Google — now includes Calendar
      </button>
      <button onClick={dismiss} aria-label="Dismiss" className="p-1 hover:text-amber-950 dark:hover:text-amber-100">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
